import { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const createTrigger = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createTrigger, { input: object })
    );
  } catch (error) {
    console.error("Error creating Trigger:", error);
    throw error;
  }
};

const updateTrigger = async (id, args) => {
  try {
    const getTriggerResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getTrigger, { id })
    );
    const currentTrigger = getTriggerResponse.data.getTrigger;

    const updateInput = { id, _version: currentTrigger._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateTrigger, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating Trigger:", error);
    throw error;
  }
};

const deleteTrigger = async (id) => {
  try {
    const getTriggerResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getTrigger, { id })
    );
    const currentTrigger = getTriggerResponse.data.getTrigger;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteTrigger, {
        input: { id, _version: currentTrigger._version },
      })
    );
    return response.data.deleteTrigger;
  } catch (error) {
    console.error("Error deleting Trigger:", error);
    throw error;
  }
};

const getTriggersByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.triggersByWorkspace, {
      workspaceID: workspaceID,
    })
  );

const getTriggersByAgentID = (agentID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.triggersByAgent, { agentID: agentID })
  );

const getTriggersByPromptID = (customPromptID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.triggersByPrompt, {
      customPromptID: customPromptID,
    })
  );

export default {
  createTrigger,
  updateTrigger,
  deleteTrigger,
  getTriggersByWorkspaceID,
  getTriggersByAgentID,
  getTriggersByPromptID,
};